
import { useEffect, useState } from 'react';
import { FaPlus } from "react-icons/fa6";
import MUITable from '../../../Common/MUITable';
import AddEditDesignations from './AddEditDesignations';
import Loader from '../../../Common/Loader/loader';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import isGHMC from '../../../Common/helper/helpar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getDesignations, GetOperations } from '../AttendanceApis';
import { ExportDesignation } from './ExportDesignations';

const Designation = () => {
    const isProd = isGHMC();
    const [ShowModal, setShowModal] = useState(false);
    const [editRow, setEditRow] = useState(null)
    const [isEditMode, setIsEditMode] = useState(false);
    const [operations, setOperations] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [isOptionsLoading, setIsOptionsLoading] = useState(false);
    const [filters, setFilters] = useState({
        operationId: '',
        IsActive: "",
    });

    let storedPermissions = localStorage.getItem("permissionId");
    const permissionValues1 =
        JSON.parse(localStorage.getItem("rolePermissions")) || {};
    let canWriteValue = null;

    // Convert storedPermissions to a number (if needed)
    storedPermissions = parseInt(storedPermissions, 10);

    // Find the matching roleToPermissionMapping object
    const matchingPermission = permissionValues1.find(
        (mapping) => mapping.permissionId === storedPermissions
    );

    if (matchingPermission) {
        canWriteValue = matchingPermission.canWrite;
    } else {
        console.log(`No match found for permission ID ${storedPermissions}`);
    }

    const getOperationsData = async () => {
        setIsOptionsLoading(true);
        try {
            const operationResponse = await GetOperations();
            setOperations(operationResponse.data);
        } catch (error) {
            console.error("Error fetching Route data:", error);
        } finally {
            setIsOptionsLoading(false);
        }
    }

    const getDesignationsData = async () => {
        setIsOptionsLoading(true);
        try {
            const DesignationsResponse = await getDesignations(filters.operationId, filters.IsActive);
            setDesignations(DesignationsResponse?.data);
            setIsOptionsLoading(false);
        } catch (error) {
            console.error("Error fetching Route data:", error);
            setIsOptionsLoading(false);
        }
    }
    useEffect(() => {
        getOperationsData();
        getDesignationsData();
    }, [])

    const handleAdd = () => {
        setIsEditMode(false); // Set to "add" mode
        setEditRow(null);
        setShowModal(true);
    };

    // Handle Filters
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleEdit = (row) => {
        setShowModal(true);
        setIsEditMode(true); // Set to "edit" mode
        setEditRow(row);
    };

    const designationColumns = [
        {
            label: "Operation",
            render: (row) => row.operationName || "N/A",
        },
        {
            label: "Designation",
            field: "designationName",
        },
        {
            label: "Status",
            render: (row) => row.isActive ? "Active" : "InActive",
        },
        {
            label: "Action",
            render: (row) => <button
                className={`${isProd ? "edit-ghmc" : "edit-swm"}`}
                onClick={() => { handleEdit(row) }}
            >
                <FontAwesomeIcon icon={faEdit} />
            </button>,
        },
    ];


    return (
        <>
            {isOptionsLoading && <Loader />}
            <div className="content text-start">
                <div className="page-content">
                    <div className="d-flex justify-content-end mt-3 align-items-center">
                        <div>
                            <div className='d-flex justify-content-between'>
                                {canWriteValue ?
                                    <button className=" button-container" onClick={handleAdd}><FaPlus className='font-size-20 me-1' /> Add Designation</button>
                                    : ""}
                                <ExportDesignation designationData={designations} />
                            </div>
                        </div>
                    </div>
                    <div className="card shadow mt-3">
                        <div className="card-body">
                            <div className="row align-items-end justify-content-start" >
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <select
                                            name="operationId"
                                            value={filters.operationId}
                                            onChange={handleFilterChange}
                                            className="form-select"
                                        >
                                            <option value="" label="Select Operation" />
                                            {operations?.filter((operation) => operation.isActive)
                                                .map((operation) => (
                                                    <option
                                                        key={operation.operationId}
                                                        value={operation.operationId}
                                                    >
                                                        {operation.operationName}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="form-group">
                                        <select
                                            name="IsActive"
                                            value={filters.status}
                                            onChange={handleFilterChange}
                                            className="form-select"
                                        >
                                            <option value="" label="Select Status" />
                                            <option value="true" label="Active" />
                                            <option value="false" label="InActive" />
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3 mb-3 text-start">
                                    <button type="button" className={`btn  search ${isProd ? "search-ghmc" : "search-swm"}`} onClick={() => getDesignationsData(filters.operationId, filters.IsActive)}>Search</button>
                                </div>
                            </div>
                            <div>
                                <div className="top-header text-center">
                                    <span>Designation Details</span>
                                </div>
                                <MUITable
                                    needSRNumber={true}
                                    rows={designations}
                                    columns={designationColumns}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddEditDesignations
                showModal={ShowModal}
                setShowModal={setShowModal}
                editRow={editRow}
                isEditMode={isEditMode}
                departmentData={operations}
                getDesignationsData={getDesignationsData}
            />
        </>
    )
}
export default Designation;